export const RPM_MONTHLY_PHONE_CONSULTATION_TITLE = "RPM Monthly Phone Consultation";
export const CCM_MONTHLY_PHONE_CONSULTATION_TITLE = "CCM Monthly Phone Consultation";

export const FAILED_VOICEMAIL_NOTE_SUBJECT = "Monthly Phone Call - Left Voicemail";
export const FAILED_VOICEMAIL_LEGACY_BODY = "Left Voicemail";

export const FAILED_VOICEMAIL_NOTE_DESCRIPTION =
  `${FAILED_VOICEMAIL_NOTE_SUBJECT} notes or legacy notes with body "${FAILED_VOICEMAIL_LEGACY_BODY}"`;

export const MONTHLY_PHONE_CONSULTATION_PROGRAMS = {
  rpm: {
    key: "rpm",
    label: "RPM",
    title: RPM_MONTHLY_PHONE_CONSULTATION_TITLE,
    shortTitle: "RPM Monthly Phone Consultations",
    description:
      "Track RPM patient outreach, documented RPM Monthly Phone Consultations, and team performance for the selected month."
  },
  ccm: {
    key: "ccm",
    label: "CCM",
    title: CCM_MONTHLY_PHONE_CONSULTATION_TITLE,
    shortTitle: "CCM Monthly Phone Consultations",
    description:
      "Track CCM patient outreach, documented CCM Monthly Phone Consultations, and team performance for the selected month."
  }
};

const buildMpcCopy = (consultationTitle, programLabel) => ({
  consultationTitle,
  failedVoicemailSubject: FAILED_VOICEMAIL_NOTE_SUBJECT,
  failedVoicemailLegacyBody: FAILED_VOICEMAIL_LEGACY_BODY,
  failedVoicemailNoteDescription: FAILED_VOICEMAIL_NOTE_DESCRIPTION,
  haveMetDescription: `Patients with a successful monthly phone consultation note documented for the selected period (${consultationTitle}). Failed phone attempts include voicemail notes before the successful call.`,
  haveNotMetDescription: `Patients without a documented ${consultationTitle} for the selected month. Voicemail outreach notes are still shown when available.`,
  haveMetTabSublabel: "Consultation documented",
  noConsultationStatus: "No consultation documented",
  consultationModalTitle: consultationTitle,
  consultationEmptyMessage: `No ${consultationTitle} documented for this period.`,
  consultationEmptyPatientMessage: `No ${consultationTitle} documented for this patient in the selected period.`,
  callsToConsultationTooltip: `Total documented ${consultationTitle}s for the patient in the selected month. Click to view details.`,
  consultationsColumnTooltip:
    `Total consultation activity for the patient in the selected month (documented ${consultationTitle}s plus ${FAILED_VOICEMAIL_NOTE_DESCRIPTION}). Click to view all details.`,
  consultationsColumnLabel: "Total Consultations Notes",
  failedAttemptsModalTitle: "Failed phone attempts",
  failedAttemptsEmptyMessage: "No unsuccessful outreach notes for this period.",
  failedAttemptsEmptyPatientMessage: "No voicemail outreach notes for this patient in the selected period.",
  teamPerformanceIntro: `See how many documented ${consultationTitle} notes each staff member and provider completed — compared to last month and their usual monthly pace. Counts are consultation notes, not patients.`,
  teamThisMonth: "This Month",
  teamLastMonth: "Last Month",
  teamTrend: "Trend",
  teamUsualPace: "Usual Pace",
  teamUsualPaceHint: "Average documented consultation notes per month over the 3 months before the selected month",
  teamAverageFormula: "Note count average = (Month 1 + Month 2 + Month 3) ÷ 3",
  teamStatNoteFootnote: "Consultation note count — not a patient count",
  teamConsultationNoteCountLabel: "consultation notes documented",
  teamTableNoteCountLabel: "notes",
  teamConsultationNotesPerMonthLabel: "consultation notes per month",
  teamThreeMonthAverageTitle: "3-Month Average — Consultation Notes",
  teamThreeMonthAverageLead: `Each number is the total documented ${consultationTitle} notes recorded by the team that month. These are note counts, not patient counts.`,
  teamThreeMonthAverageMonthSublabel: "consultation notes",
  teamMonthColumnSubtitle: "Consultation notes documented",
  teamTableSectionTitle: "Consultation Notes by Team Member",
  teamTableSectionSubtitle:
    "Documented consultation note counts by month, plus trend and usual pace. Sorted by selected month (highest first). Filter by role, search, or export below.",
  teamRoleFilterLabel: "Role",
  teamRoleFilterAll: "All roles",
  teamRoleFilterStaff: "Staff",
  teamRoleFilterProvider: "Provider",
  teamMemberDetailEmptyMessage: `No ${consultationTitle} notes documented for this team member in the selected month.`,
  teamCountClickHint: "Click a note count to view patients and consultation details for that month.",
  teamTablePeriodLegendPrefix: "Showing consultation note counts for",
  programLabel
});

export const MPC_COPY_BY_PROGRAM = {
  rpm: buildMpcCopy(RPM_MONTHLY_PHONE_CONSULTATION_TITLE, "RPM"),
  ccm: buildMpcCopy(CCM_MONTHLY_PHONE_CONSULTATION_TITLE, "CCM")
};

export const normalizeProgramType = (programType) => {
  const normalized = String(programType || "rpm").toLowerCase();
  return MONTHLY_PHONE_CONSULTATION_PROGRAMS[normalized]
    ? normalized
    : MONTHLY_PHONE_CONSULTATION_PROGRAMS.rpm.key;
};

export const getMpcCopy = (programType) =>
  MPC_COPY_BY_PROGRAM[normalizeProgramType(programType)] || MPC_COPY_BY_PROGRAM.rpm;

export const getConsultationTitle = (programType) =>
  getMpcCopy(programType).consultationTitle;

/** @deprecated Use getMpcCopy(programType) */
export const MPC_COPY = MPC_COPY_BY_PROGRAM.rpm;
